import React, { FC } from 'react';
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ListViewProfile } from 'models/organization';
import { isSystemDefaultProfile } from './column-registry';

type ListViewProfileSelectorProps = {
    profiles: ListViewProfile[];
    activeProfileId: string;
    onChange: (profileId: string) => void;
};

const ListViewProfileSelector: FC<ListViewProfileSelectorProps> = ({ profiles, activeProfileId, onChange }) => {
    const { t: translate } = useTranslation(['lab-settings']);

    const handleChange = (event: SelectChangeEvent<string>) => {
        onChange(event.target.value);
    };

    const labelId = 'list-view-profile-selector-label';
    const label = translate('lab-settings:LIST_VIEW');

    return (
        <FormControl size="small" sx={{ minWidth: 200 }}>
            <InputLabel id={labelId}>{label}</InputLabel>
            <Select labelId={labelId} value={activeProfileId} onChange={handleChange} label={label}>
                {profiles.map((profile) => (
                    <MenuItem key={profile._id} value={profile._id}>
                        {isSystemDefaultProfile(profile)
                            ? translate('lab-settings:LIST_VIEW_PROFILE_SYSTEM_DEFAULT')
                            : profile.name}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default ListViewProfileSelector;
